"use strict";



//////////////////
// WEBPACK FOOTER
// ./interfaces/slider.interface.ts
// module id = 13
// module chunks = 0